import { List } from 'immutable'

export const getGroupsFromToken = (authToken) => {
  if (authToken) {
    return List(JSON.parse(atob(authToken.split('.')[1])).grp.sort())
  } else {
    return new List()
  }
}
